import * as React from 'react';
import type { Path, PathValue, UseFormGetValues } from 'react-hook-form';
import { type FieldValues, type UseControllerProps } from 'react-hook-form';

import type { CellError } from '../../RHFTableCellComponents/error.types';
import { DisplayCell } from '../../RHFTableCellComponents/TextArea/DisplayCell';
import RHFUnregisteredFieldWrapper from '../RHFUnregisteredFieldWrapper';

type Props<T extends FieldValues> = UseControllerProps<T> & {
	rhfId: number | string;
	placeholder?: string;
	getValues: UseFormGetValues<T>;
};

function TextArea<T extends FieldValues>(props: Props<T>) {
	const { name, rhfId, placeholder, ...rest } = props;

	const renderTextArea = React.useCallback((
		{ value, error }: {
			value: PathValue<T, keyof T & Path<T>>;
			error: Nullable<CellError>;
		}) => (
		<DisplayCell
			elementKey={`${rhfId}`}
			error={error ?? undefined}
			name={name}
			placeholder={placeholder}
			value={value}
		/>
	),
		[name, rhfId, placeholder]
	);

	return (
		<RHFUnregisteredFieldWrapper<T>
			name={name}
			{...rest}
			render={renderTextArea}
		/>
	);
}

export default React.memo(TextArea) as typeof TextArea;

